<div class="container">
  <div class="col-sm-12 breadcrumb py-3 m-0">
    <a href="#">Favoris</a>
  </div>
</div>
<div class="container">
        <div class="row">
              <div class="col-sm-12 sousTitreRubrique text-center">
                 Favoris
                 <div class="separTitres"></div>
              </div>
        </div>
        <div class="row">
            <table class="table panier">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Produit</th>
                    <th scope="col">Ref</th>
                    <th scope="col">Prix</th>
                    <th scope="col">Retirer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of favoris">
                    <th scope="row"><div class="text-center"><a [routerLink]="['/product-details/',item.ITMREF]"><img onerror="this.onerror=null;this.src='assets/front/images/logo.png';"  src="{{baseUrl}}/{{item.VIG}}" height="150px"></a></div></th>
                    <td class="titleProductCart"><a [routerLink]="['/product-details/',item.ITMREF]"><h6>{{item.ITMDES1}}</h6></a></td>
                    <td><p>{{item.ITMREF}}</p></td>
                    <td><p>{{item.PRIXBRUT}} MAD</p></td>
                    <td><div class="text-center"><img src="assets/front/images/trash-o.png" (click)="removeItem(item.ITMREF)"></div></td>
                  </tr>
                </tbody>
              </table>
        </div>


      </div>
